module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" "), _c('org-badge'), _vm._v(" Backhaul Dashboard"), (!_vm.isTowerCo() && _vm.org().shortName) ? _c('small', {
    staticClass: "text-info pull-right hidden-sm-and-down"
  }, [_vm._v(_vm._s(_vm.org().name))]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Providers",
      "name": "provider"
    }
  }, [_c('backhaul-provider-summary')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Customers",
      "name": "subscriber"
    }
  }, [_c('backhaul-subscriber-summary')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Sites by Provider",
      "name": "sites"
    }
  }, [_c('backhaul-table', {
    attrs: {
      "no-add": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e55812ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/backhaul/BackhaulDashboard.vue
// module id = 1727
// module chunks = 0